import ApiBase from '../../shared/api/api-base'

export default class Dashboard extends ApiBase {
  constructor(store) {
    const path = 'pub/dashboard'
    super(path, store)
  }
  totalData(params) {
    return this._request({
      action: 'total-data',
      method: 'GET',
      params
    })
  }
}
